import { Component, OnInit, Input, Output, OnChanges } from '@angular/core';
import {MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import { Program } from './shared/program.model';
import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent implements OnInit , OnChanges {
  @Input() programs: Program [];
  displayedColumns: string[] = ['select', 'code', 'name', 'version', 'type', 'state'];
  dataSource:  MatTableDataSource<Program>;
  selectedProgram: Program;

  constructor() { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource<Program>(this.programs);
  }

  ngOnChanges() {
    this.dataSource = new MatTableDataSource<Program>(this.programs);
  }

  getItemSelected(itemSelected) {
    this.selectedProgram = itemSelected;
  }

}
